import { Component, h, Listen, State } from '@stencil/core';
import { type SelectedAccount, type SelectedItem, storage } from '../rtr-debug-toolbar/utils/storage';

@Component({
  tag: 'rtr-debug-header-info',
  shadow: false,
})
export class RtrDebugHeaderInfo {
  @State() selectedAccount: SelectedAccount | null = null;
  @State() selectedItem: SelectedItem | null = null;

  componentWillLoad() {
    // Load initial state
    this.selectedAccount = storage.getSelectedAccount();
    this.selectedItem = storage.getSelectedItem();
  }

  componentDidLoad() {
    // Listen for storage events (cross-window changes)
    window.addEventListener('storage', this.handleStorageChange);
  }

  disconnectedCallback() {
    window.removeEventListener('storage', this.handleStorageChange);
  }

  // Listen for custom events dispatched from storage.setSelectedAccount/setSelectedItem (same-window changes)
  @Listen('debug-selected-account-changed', { target: 'window' })
  handleAccountChanged(event: CustomEvent<SelectedAccount | null>) {
    this.selectedAccount = event.detail;
  }

  @Listen('debug-selected-item-changed', { target: 'window' })
  handleItemChanged(event: CustomEvent<SelectedItem | null>) {
    this.selectedItem = event.detail;
  }

  // Handle storage events (for cross-window changes)
  private handleStorageChange = (event: StorageEvent) => {
    if (event.key === 'rentware-debug-selected-account') {
      this.selectedAccount = event.newValue
        ? JSON.parse(event.newValue)
        : null;
    } else if (event.key === 'rentware-debug-selected-item') {
      this.selectedItem = event.newValue ? JSON.parse(event.newValue) : null;
    }
  };

  render() {
    return (
      <div class="flex items-center gap-x-4 gap-y-2 flex-wrap">
        {this.selectedAccount && (
          <div>
            <span>Account: {this.selectedAccount.name}</span>
          </div>
        )}
        {this.selectedItem && (
          <div>
            <span>Item: {this.selectedItem.name}</span>
          </div>
        )}
      </div>
    );
  }
}

